<template>
  <div style="padding: 20px">
    <div class="flex-title">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <h2>Consultar Avaliação Individual - {{ nomeAvaliacao }}</h2>
    </div>

    <div v-if="!linhas.length">
      <h4 style="padding: 30px">
        Essa avaliação não recebeu nenhuma resposta.
      </h4>
    </div>

    <table v-else class="data-table">
      <thead>
        <tr>
          <th class="text-left project-name">{{ this.nomeProjeto }}</th>

          <th
            v-for="avaliador in avaliadores"
            :key="avaliador"
            class="text-center"
          >
            {{ formatarNomeCurto(avaliador) }}
          </th>

          <th class="text-center">Comentários</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="linha in linhas" :key="linha.avaliado">
          <td class="cell-bold">
            {{ formatarNomeCurto(linha.avaliado) }}
          </td>

          <td
            v-for="avaliador in avaliadores"
            :key="avaliador"
            class="text-center"
          >
            <span class="nota">
              {{ linha.notas[avaliador] ?? '-' }}
            </span>
          </td>

          <td class="text-center">
            <v-btn
              prepend-icon="mdi-comment-text-outline"
              variant="text"
              @click="openComments(linha)"
              :disabled="linha.comentarios.length === 0"
            >
              Ver comentários
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <v-dialog v-model="dialogComentarios" max-width="600px">
      <v-card>
        <v-card-title class="text-h6">
          Comentários — {{ avaliadoSelecionado }}
        </v-card-title>

        <v-divider />

        <v-card-text>
          <v-alert
            v-if="!comentariosSelecionados.length"
            type="info"
            variant="tonal"
          >
            Nenhum comentário foi feito para este avaliado.
          </v-alert>

          <v-list v-else>
            <v-list-item
              v-for="(c, i) in comentariosSelecionados"
              :key="i"
              class="comments-list"
            >
              <v-list-item-title>
                {{ c.autor }}
              </v-list-item-title>

              <v-list-item-subtitle>
                {{ c.texto }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialogComentarios = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';

import QuestionSet from '@/components/QuestionSet.vue';
import store from '@/store/store';
/* eslint-disable */
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    QuestionSet,
  },
  async mounted() {
    await this.fetch();
  },
  data: () => ({
    avaliadores: [],
    linhas: [],
    dialogComentarios: false,
    comentariosSelecionados: [],
    avaliadoSelecionado: '',
  }),

  created() {
    this.idAvaliacao = this.$route.params.id;
    this.nomeAvaliacao = this.$route.params.nomeAvaliacao;
    this.idProjeto = this.$route.params.id_proj;
    this.nomeProjeto = this.$route.params.nomeProjeto;
  },

  methods: {
    formatarNomeCurto(nomeCompleto) {
      if (!nomeCompleto) return '';

      const partes = nomeCompleto.trim().split(/\s+/);

      // Apenas nome
      if (partes.length === 1) return partes[0];

      // Nome + primeiro sobrenome
      return `${partes[0]} ${partes[1]}`;
    },

    openComments(linha){
      this.dialogComentarios = true
      this.comentariosSelecionados = linha.comentarios;
      this.avaliadoSelecionado = linha.avaliado;
    },

    async fetch() {
      const response = await axios.get(
        API_URL +
          `/avaliacaoIndividual/${this.idAvaliacao}/${this.idProjeto}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        }
      );

      const avaliadoresSet = new Set();
      const avaliadosMap = {};

      response.data.forEach((resp) => {
        resp.tb_avaliacao_individual.forEach((aval) => {
          const avaliado =
            aval.tb_usuario_tb_avaliacao_individual_id_usuario_avaliadoTotb_usuario
              .nome;
          const avaliador =
            aval.tb_usuario_tb_avaliacao_individual_id_usuario_avaliadorTotb_usuario
              .nome;

          avaliadoresSet.add(avaliador);

          if (!avaliadosMap[avaliado]) {
            avaliadosMap[avaliado] = {
              avaliado,
              notas: {},
              comentarios: [],
            };
          }

          avaliadosMap[avaliado].notas[avaliador] = aval.numero_pontos;

          if (aval.comentario) {
            avaliadosMap[avaliado].comentarios.push({
              autor: avaliador,
              texto: aval.comentario,
            });
          }
        });
      });

      this.avaliadores = Array.from(avaliadoresSet);
      this.linhas = Object.values(avaliadosMap);
    }
  },
};
</script>

<style scoped>
.flex-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.data-table {
  margin-top: 50px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: #ffffff;
  font-size: 14px;
  color: #424242;
}

/* HEADER */
.data-table thead th {
  font-weight: 600;
  padding: 20px 14px;
  border-bottom: 1px solid #e0e0e0;
}

/* LINHAS */
.data-table tbody tr {
  transition: background-color 0.2s ease;
}

/* CÉLULAS */
.data-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #eeeeee;
  vertical-align: center;
}

.project-name {
  text-transform: uppercase;
}

.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.cell-bold {
  font-weight: 500;
}

/* NOTAS */
.nota {
  display: inline-block;
  min-width: 28px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 13px;
}

/* COMENTÁRIOS */
.comentarios {
  padding-left: 16px;
  margin: 0;
}

.comentarios li {
  margin-bottom: 4px;
}

.comments-list{
  font-weight: medium;
  padding: 6px 0px;
}
</style>

